import script from "./EventPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EventPage.vue?vue&type=script&setup=true&lang=js"

import "./EventPage.vue?vue&type=style&index=0&id=c3ef1cb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3ef1cb2"]])

export default __exports__